
class SwoopingStudy {



    constructor(sketch, w, h, ps, dp) {
        this.sketch = sketch;
        this.w = w;
        this.h = h;
        this.dp = dp;

        this.center = sketch.createVector(w / 2, h / 2);

        this.ps = ps;
        this.particles = ps.systemParticles();

        this.phaseNumber = 1;

        this.sum = 0;
        this.pSum = 0;
        this.cumulativeSum = 0;
    }

    reset() {

        this.phaseNumber = 1;

        this.sum = 0;
        this.pSum = 0;
        this.cumulativeSum = 0;
    }

    draw() {

        //sum = d.sum();
        this.sum = this.dp.sum();

        if (this.dp.shouldSwitchPhase() == true) {

            this.pushPhase();

        }

        // center = new PVector(mouseX, mouseY);

        let difference = this.sketch.constrain(this.sum - this.pSum, -50, 50);

        let rotationAngleAddition = this.sketch.map(Math.abs(difference), 0, 50, 0, this.sketch.TWO_PI);

        let constrainedSum = this.sketch.constrain(this.sum, 0, 127 * 4);

        let rotationAngle = this.sketch.map(constrainedSum, 0, 127 * 4, 0, this.sketch.TWO_PI);
        rotationAngle = this.sum * (this.sketch.TWO_PI / 360 / 8);


        let sign = difference < 0 ? -1 : 1;

        if (difference > 0) {
            this.cumulativeSum += (sign * rotationAngleAddition * 0.001);
        } else {
            this.cumulativeSum *= 0.998;

        }


        //println("SSS", sum - pSum);

        this.pSum = this.sum;


        for (let mi = 0; mi < this.ps.systemParticles().length; mi++) {
            let p = this.ps.systemParticles()[mi];
            let i = p.index;
            let px = p.cx;
            let py = p.cy;
            let ox = p.oscillationXValue;
            let oy = p.oscillationYValue;

            if (p.isOscillationX || p.isOscillationY) {

                p.updateOscillationPosition();
            }



            this.sketch.push();
            this.sketch.translate(this.center.x, this.center.y);
            //rotate(rotationAngle * (i % 20));
            this.sketch.rotate(this.cumulativeSum * (i % 15)); // i % 30
            p.renderAtPosition(px - this.center.x, py - this.center.y);
            this.sketch.pop();

        }


    }



    pushPhase() {

        if (this.phaseNumber < 2) {

            this.phaseNumber += 1;
        }
    }

    moveCenter(x, y) {
        this.center = this.sketch.createVector(x, y);
    }


}

export default SwoopingStudy;